import { CardHeader } from "reactstrap";
import { H3 } from "../../../../AbstractElements";
import { ScrollVaertical1, ScrollVaertical2, ScrollVerticalDynamicHeightTitle } from "../../../../Constant";

const ScrollVaerticalHeader = () => {
  return (
    <CardHeader className="pb-0 card-no-border">
      <H3>{ScrollVerticalDynamicHeightTitle}</H3>
      <span>{ScrollVaertical1}</span>
      <span>{ScrollVaertical2}</span>
    </CardHeader>
  );
};

export default ScrollVaerticalHeader;
